import { TodoActionTelemetryData } from 'owa-todo-actions';
import { ContextMenuTodoActionTelemetryData } from '../schema/ContextMenuTodoActionTelemetryData';

export function getTodoActionTelemetryData(
    cmData: ContextMenuTodoActionTelemetryData
): TodoActionTelemetryData {
    return {
        viewType: 'ItemContextMenu',
        ...cmData,
    };
}
